import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import { ButtonCust, CustToolTip } from "../../../widgets";
import Config from "../../../../config/env.config.json";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import CustomDateCalendar from "../../../common/DateCalander/CustomDateCalendar";
import styles from "./S1_GlobalRoamingPack.module.scss";
import PaymentReviewCard from "../PaymentReviewCard/PaymentReviewCard";
import PaymentStatus from "../PaymentStatus/PaymentStatus";
import { PostActivationIRILDEnums } from "../../../../enums";
import { resetPurchasePack } from "../../../../features/services/servicesSlice";

function T1GlobalRoamingPack(props: any) {
  const { content, fullName } = props.props;
  const {
    back_btn,
    GR_pack,
    termCondition,
    GR_icons,
    visa_card,
    calendarPen,
    calendar_data,
    carbon_edit,
    termTooltip,
    payment_review,
    success,
    failed,
    payment_status,
    back_arrow,
  } = content;

  const {
    setIsGlobalRoamingPack,
    calanderOnChangeHandler,
    paymentFailedBack,
    confirmPurchaseHandler,
    calanderSubmitHandler,
    selectPackHandler,
    combinedSelectedPackReviewData,
    country,
    onChangeAutoRenewal,
    dateFormat,
    isCalendarModal,
    isPaymentReviewCard,
    isTooltip,
    setIsTooltip,
    purchasePackStatus,
    displayName,
    autoRenewal,
    selectedDate,
    setisCalendarModal,
  } = props;
  const { onClickSwitchTabs, setIsCountryList } = props.props;
  const availableOfferingsData = useAppSelector(
    (state) => state.services?.availableOfferings
  );

  const { purchasePackError, purchasePackSuccess, purchasePackLoading } =
    useAppSelector((state) => state.services);

  const { IRTaxCharges, isLoadedIRTaxCharges } = useAppSelector(
    (state: any) => state.checkout
  );

  const dispatch = useAppDispatch();

  return (
    <>
      {purchasePackError && (
        <PaymentStatus
          icon={failed}
          title={payment_status.failedTitle}
          description={payment_status.failedDesc}
          button={payment_status.failedBtn}
          back_btn={back_btn}
          onClick={() => confirmPurchaseHandler()}
          onBackClick={paymentFailedBack}
          variantType={Config.QUATERNARY_BUTTON_TYPE}
          backIcon={back_arrow}
        />
      )}

      {purchasePackLoading && (
        <Box textAlign={"center"}>
          <CircularProgress sx={{ color: "var(--primary_color)" }} />
        </Box>
      )}

      {purchasePackSuccess && (
        <PaymentStatus
          icon={success}
          title={payment_status.successTitle}
          description={`${payment_status.successDesc} ${dateFormat()}.`}
          button={payment_status.successBtn}
          onClick={() => {
            setIsCountryList(false);
            onClickSwitchTabs(PostActivationIRILDEnums.tab_right);
            dispatch(resetPurchasePack());
            localStorage.removeItem("selectedPack");
            localStorage.removeItem("postActivationDate");
            localStorage.removeItem("prRoamingCountry");
            localStorage.removeItem("SingleLineData");
          }}
          variantType={Config.QUATERNARY_BUTTON_TYPE}
        />
      )}

      {!purchasePackStatus && (
        <Box
          m={{ xs: "auto", sm: "auto", md: "auto" }}
          width={{ xs: "auto", sm: "auto", md: "60%" }}
          className={styles.main_container}
        >
          <CustomDateCalendar
            onClick={calanderSubmitHandler}
            onChange={calanderOnChangeHandler}
            isCalanderModal={isCalendarModal}
            onCloseModal={setisCalendarModal}
            title={calendar_data.title}
            desc={calendar_data.desc}
            button={calendar_data.btn_2}
            variant={Config.QUATERNARY_BUTTON_TYPE}
          />
          <Typography className={styles.top_heading}>
            <Typography
              className={styles.back_arrow}
              onClick={() => setIsGlobalRoamingPack("")}
            >
              {/* Add your arrow icon here */}
              <img
                src={back_arrow?.data.attributes.url}
                alt={back_arrow?.data.attributes.alternativeText}
                width={17.495}
                height={14.586}
              />
              {back_btn}
            </Typography>
            <span style={{ margin: "auto" }}>
              {isPaymentReviewCard ? payment_review.title : GR_pack.title}
            </span>
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Typography className={styles.country_label}>
                <span
                  style={{ opacity: 0.7, fontWeight: "var(--font_weight_1)" }}
                >
                  {GR_pack.country}
                  <span style={{ marginRight: "1px" }}>: </span>
                </span>
                <span style={{ fontWeight: "var(--font_weight_5)" }}>
                  {JSON.parse(country || "{}").name}
                </span>
              </Typography>
              <Typography display={"flex"} justifyContent={"flex-start"}>
                <span className={styles.schedule}>{GR_pack.scheduleFor}</span>
                <span style={{ margin: "0 5px" }}>: </span>
                <span className={styles.selected_date}>
                  {selectedDate ? selectedDate : dateFormat()}
                </span>
                <img
                  style={{ marginLeft: "21px" }}
                  onClick={() => setisCalendarModal(true)}
                  src={calendarPen.data.attributes.url}
                />
              </Typography>
            </Box>
            <Box>
              <Typography className={styles.full_name}> {fullName}</Typography>
            </Box>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={3}>
            {/*Mapping the data  */}

            {!isPaymentReviewCard ? (
              availableOfferingsData.length === 0 ? (
                <Box textAlign={"center"}>
                  <CircularProgress sx={{ color: "var(--primary_color)" }} />
                </Box>
              ) : (
                availableOfferingsData.map((data: any) => {
                  return (
                    <Box key={data.id}>
                      <Box display={"flex"} justifyContent={"space-between"}>
                        <Typography className={styles.display_name}>
                          <span>{data?.displayName}</span>
                          <span className={styles.display_name_service_unit}>
                            {" "}
                            {data.data}
                            {data.dataUnit}
                          </span>
                        </Typography>
                        <Typography className={styles.data_cost}>
                          ${data.price.toFixed(2)}
                        </Typography>
                      </Box>
                      <Box key={data.id} className={styles.card_sub_container}>
                        <Box textAlign={"center"}>
                          <Typography
                            className={styles.card_sub_container_title}
                          >
                            {GR_pack.data}{" "}
                            <img
                              alt={GR_icons.data[0].attributes.alternativeText}
                              src={GR_icons.data[0].attributes.url}
                            />
                          </Typography>
                          <Typography
                            className={styles.card_sub_container_value}
                          >
                            {data.data}GB
                          </Typography>
                        </Box>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ borderRightWidth: 2 }}
                        />
                        <Box textAlign={"center"}>
                          <Typography
                            className={styles.card_sub_container_title}
                          >
                            {GR_pack.voice}{" "}
                            <img
                              alt={GR_icons.data[1].attributes.alternativeText}
                              src={GR_icons.data[1].attributes.url}
                            />
                          </Typography>
                          <Typography
                            className={styles.card_sub_container_value}
                          >
                            {data.voice}mins
                          </Typography>
                        </Box>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ borderRightWidth: 2 }}
                        />
                        <Box textAlign={"center"}>
                          <Typography
                            className={styles.card_sub_container_title}
                          >
                            {GR_pack.sms}{" "}
                            <img
                              alt={GR_icons.data[2].attributes.alternativeText}
                              src={GR_icons.data[2].attributes.url}
                            />
                          </Typography>
                          <Typography
                            className={styles.card_sub_container_value}
                          >
                            {data.sms}
                          </Typography>
                        </Box>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ borderRightWidth: 2 }}
                        />
                        <Box textAlign={"center"}>
                          <Typography
                            className={styles.card_sub_container_title}
                          >
                            {GR_pack.mms}{" "}
                            <img
                              alt={GR_icons.data[3].attributes.alternativeText}
                              src={GR_icons.data[3].attributes.url}
                            />
                          </Typography>
                          <Typography
                            className={styles.card_sub_container_value}
                          >
                            {data.mms}
                          </Typography>
                        </Box>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ borderRightWidth: 2 }}
                        />
                        <Box textAlign={"center"}>
                          <Typography
                            className={styles.card_sub_container_title}
                          >
                            {GR_pack.validity}{" "}
                            <img
                              alt={GR_icons.data[4].attributes.alternativeText}
                              src={GR_icons.data[4].attributes.url}
                            />
                          </Typography>
                          <Typography
                            className={styles.card_sub_container_value}
                          >
                            {data.validityDays}{" "}
                            {data.validityDays === 1 ? "day" : "days"}
                          </Typography>
                        </Box>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ borderRightWidth: 2 }}
                        />
                        <ButtonCust
                          variantType={Config.QUATERNARY_BUTTON_TYPE}
                          onClick={() => selectPackHandler(data)}
                        >
                          {GR_pack.pack_btn}
                        </ButtonCust>
                      </Box>
                    </Box>
                  );
                })
              )
            ) : (
              <PaymentReviewCard
                onChangeAutoRenewal={onChangeAutoRenewal}
                autoRenewal={autoRenewal}
                isAutoRenewal={Config.ENABLE_IR_DATA_RENEWAL}
                firstRowTitle={`${displayName} ${combinedSelectedPackReviewData.data}${combinedSelectedPackReviewData.dataUnit}`}
                firstRowValue={combinedSelectedPackReviewData.dataCost}
                secondRowTitle={combinedSelectedPackReviewData.secondRow}
                secondRowValue={IRTaxCharges}
                thirdRowTitle={combinedSelectedPackReviewData.thirdRow}
                mockCard={combinedSelectedPackReviewData.mockCard}
                loading={isLoadedIRTaxCharges}
                autoRenewalTitle={
                  combinedSelectedPackReviewData?.autoRenewal.title
                }
                visa_card={visa_card?.data?.attributes}
                carbon_edit={carbon_edit.data.attributes}
                data={combinedSelectedPackReviewData}
                grPack={GR_pack}
                displayName={displayName}
                toggleTrueText={
                  combinedSelectedPackReviewData?.autoRenewal.toggleTrue
                }
                toggleFalseText={
                  combinedSelectedPackReviewData?.autoRenewal.toggleFalse
                }
                onClick={confirmPurchaseHandler}
                confirmBtn={combinedSelectedPackReviewData.cnfrmBtn}
                changeCardText={combinedSelectedPackReviewData.ChangeCard}
              />
            )}
          </Box>
          {!isPaymentReviewCard && (
            <Typography
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              className={styles.term_condition}
              sx={{ textAlign: "center" }}
            >
              {GR_pack.termsConditions}
              <CustToolTip
                title={
                  <Box>
                    <ol
                      style={{
                        padding: "10px 40px",
                        listStyleType: "decimal",
                      }}
                    >
                      {termTooltip?.map((list: any, index: any) => (
                        <li
                          style={{ padding: "5px", lineHeight: "20px" }}
                          key={index}
                          dangerouslySetInnerHTML={{ __html: list.label }}
                        ></li>
                      ))}
                    </ol>
                  </Box>
                }
                onClick={() => setIsTooltip((prev: any) => !prev)}
                placement="top"
                open={isTooltip}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                arrow
              >
                <img
                  src={termCondition?.data?.attributes?.url}
                  alt={termCondition?.data?.attributes?.alternativeText}
                  width={18}
                  height={18}
                  style={{ marginLeft: "5px" }}
                />
              </CustToolTip>
            </Typography>
          )}
        </Box>
      )}
    </>
  );
}

export default T1GlobalRoamingPack;
